import PropTypes from 'prop-types';
export const authorTilePropTypes = {
  /**
   * Picture data: src and alt
   */
  picture: PropTypes.exact({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  /**
   * Author's page href
   */
  href: PropTypes.string,
  /**
   * Author's role
   */
  role: PropTypes.string,
  /**
   * Author's name
   */
  name: PropTypes.string,
  /**
   * Author's description
   */
  description: PropTypes.string,
  /**
   * verifiedLabel content
   */
  verifiedLabel: PropTypes.string,
  /**
   * Links to socials: Muckrack and LinkedIn
   */
  socials: PropTypes.exact({
    muckrack: PropTypes.string,
    linkedin: PropTypes.string
  })
};